<template>
  <tender-form-label :key="index" 
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
  >
    <span class="latest-years-word">
      近
    </span>
    <bear-input class="latest-years-input" 
      v-model.trim="form[options.Key]" 
      :attrs="attrs" 
      @input="inputChangeHandle"
    ></bear-input>
    <span class="latest-years-word">
      年（指
    </span>
    <template v-for="(obj, i) in yearsList" :key="i">
      <bear-input class="latest-years-input" 
        v-model.trim="yearsList[i]" 
        :attrs="attrs" 
        @input="inputChangeHandle"
      ></bear-input>
      <span class="latest-years-word">
        年度<span v-if="i !== yearsLength - 1">、</span>
      </span>
    </template>
    <span class="latest-years-word">
      ）
    </span>
  </tender-form-label>
</template>
<script>
import BearInput from '~@/input/src'
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
export default {
  name: 'FormInputLatestYears',
  mixins: [mixForFormItem],
  components: {BearInput},
  computed: {
    listKey() {
      return `${this.options.Key}_LIST`
    },
    yearsList() {
      return this.form[this.listKey]
    },
    yearsLength() {
      let {form, options} = this
      let years = form[options.Key]
      if(/^\d+$/.test(years)) {
        return years - 0
      } else {
        return 0
      }
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}, listKey} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        this.setFormItemValue(options.Value || '')
        this.form[listKey] = []
      }).catch(() => null)
    },
    inputChangeHandle() {
      let {yearsLength, listKey} = this
      let list = this.form[listKey]
      
      this.$nextTick(() => {
        if(list.length >= yearsLength) {
          list.length = yearsLength
        } else {
          while(list.length < yearsLength) {
            list.push('')
          }
        }

        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.latest-years-input {
  vertical-align: text-top;
}
.latest-years-word {
  text-indent: 0;
  display: inline-block;
  vertical-align: text-top;
}
</style>
<style lang="scss">
.tender-form-item {
  .is-error {
    .latest-years-word {
      &+.el-form-item__error {
        display: none;
      }
    }
  }
}
</style>
